export enum EmailTemplateType {
	Invitation = 1,
	Reminder = 2,
}
